import { createFileRoute } from '@tanstack/react-router'
import { currentUserQuery } from '../features/admin/queries'
import { KnowledgeScreen } from '../features/knowledge'
import { knowledgeProposalsQuery, knowledgeQuery } from '../features/knowledge/queries'

export const Route = createFileRoute('/knowledge')({
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(knowledgeQuery()),
      context.queryClient.ensureQueryData(knowledgeProposalsQuery()),
      context.queryClient.ensureQueryData(currentUserQuery()),
    ]),
  component: KnowledgeScreen,
})
